import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProductType, PageType } from '../../types/product.type';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SxImageAssetPickerComponent } from './imageAssetPicker.component';
import { AssetsService, SponsorAssetFile } from '../../../../infrastructure/services/assets.service';

@Component({
  selector: 'sx-asset-input',
  templateUrl: './asset-input.component.html'
})
export class SxAssetInputComponent implements OnInit {
  @Input('product') product: ProductType | PageType;
  @Input('selected') selected: string;
  @Output('selectedChanged') selectedChanged: EventEmitter<string> = new EventEmitter();
  @Output('createNew') createNew: EventEmitter<string> = new EventEmitter();
  assetImages;

  constructor(private modalService: NgbModal,
              private assetService: AssetsService) {
  }

  ngOnInit(): void {
  }

  select(asset: SponsorAssetFile) {
    this.selected = asset.codAsset;
    this.selectedChanged.emit(this.selected);
  }

  open() {
    const modal = this.modalService.open(SxImageAssetPickerComponent, { backdrop: 'static' });
    const modalRef = <SxImageAssetPickerComponent>modal.componentInstance;
    this.assetImages = this.obtenerAssets();
    modalRef.assetImages = this.assetImages;
    modalRef.selected = this.selected;
    modal.result.then((result) => {
        this.selected = result;
        this.selectedChanged.emit(this.selected);
      }, (reason) => {
      });
  }

  obtenerAssets() {
    return this.assetService.getByTipo('imagen',
      this.product.codSistema,
      this.product.codNegocio,
      this.product.codNegocio,
      this.product.codProducto);
  }

  createNewAsset(): void {
    this.createNew.emit(this.selected);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/shared/asset-input.component.ts